// src/components/NavBar.js
import React from 'react';
import { View, Pressable, Text, StyleSheet } from 'react-native';

export default function NavBar({ navigation }) {
  return (
    <View style={styles.navBarContainer}>
      <Pressable
        style={({ hovered, pressed }) => [
          styles.navButton,
          hovered && styles.navButtonHovered,
          pressed && styles.navButtonPressed,
        ]}
        onPress={() => navigation.navigate('Home')}
      >
        <Text style={styles.navButtonText}>Home</Text>
      </Pressable>

      <Pressable
        style={({ hovered, pressed }) => [
          styles.navButton,
          hovered && styles.navButtonHovered,
          pressed && styles.navButtonPressed,
        ]}
        onPress={() => navigation.navigate('Profile')}
      >
        <Text style={styles.navButtonText}>Profile</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  navBarContainer: {
    flexDirection: 'row',
    width: '100%',
    height: 80, // A bit taller for easy tapping
    backgroundColor: '#1C1C1E', // A slightly different dark color
    borderTopWidth: 1,
    borderTopColor: '#3A3A3C',
    justifyContent: 'space-around',
    alignItems: 'flex-start', // Align text to the top
    paddingTop: 10,
    paddingBottom: 20, // Padding for devices with a home indicator
    overflow: 'hidden',
  },
  navButton: {
    padding: 10,
    alignItems: 'center',
  },
  navButtonHovered: {
    opacity: 0.8,
    cursor: 'pointer',
  },
  navButtonPressed: {
    opacity: 0.6,
  },
  navButtonText: {
    color: '#FCD000',
    fontSize: 16,
    fontWeight: 'bold',
  },
});